module.exports = __webpack_public_path__ + "img/icon-customer-i5gam.jkUse.be327c47.png";